<template>
  <div>
    <confirm-modal
        v-model="modalExcluir"
        @modalAcaoCancelar="fecharModalExcluirAtendimento"
        @modalAcaoConfirmar="excluirAtendimento"
        :persistencia="false"
        mensagemInicial="Deseja realmente excluir o atendimento "
        :mensagemMeio="dadosGeraisAtendimento.codigo"
        mensagemFinal="?"
    />
    <cancelar-atendimento-modal
        v-if="modalCancelarAtendimento"
        v-model="modalCancelarAtendimento"
        @fecharModalCancelar="fecharModalCancelarAtendimento"
        @confirmarCancelarAtendimento="cancelarAtendimento"
    />
    <confirm-modal
        v-if="modalFinalizarAtendimento"
        v-model="modalFinalizarAtendimento"
        @modalAcaoCancelar="fecharModalFinalizarAtendimento"
        @modalAcaoConfirmar="finalizarAtendimento"
        :persistencia="false"
        text-confirmar="Finalizar"
        corConfirmar="#22bb33"
        mensagemInicial="Deseja realmente finalizar o atendimento "
        :mensagemMeio="dadosGeraisAtendimento.codigo"
        mensagemFinal="?"/>
    <div
        :class="{'atendimento-wrapper': exibirMenuLateralEsquerdo, 'atendimento-wrapper-recolhido': !exibirMenuLateralEsquerdo}">
      <v-card elevation="0" class="container-atendimento">
        <v-card-title>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="fecharAtendimentoSelecionado" icon color="white">
                <v-icon>arrow_back</v-icon>
              </v-btn>
            </template>
            Voltar
          </v-tooltip>
          <v-toolbar-title v-if="dadosGeraisAtendimento.codigo" class="ml-2">Atendimento:
            {{
              dadosGeraisAtendimento.codigo
            }}
          </v-toolbar-title>
          <v-toolbar-title v-else class="ml-2">Atendimento
            agendado
          </v-toolbar-title>
          <v-spacer/>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="recolherExpandirMenuLateral" icon color="white">
                <v-icon>{{
                    exibirMenuLateralEsquerdo ? 'mdi-arrow-left-bold-box-outline' : 'mdi-arrow-right-bold-box-outline'
                  }}
                </v-icon>
              </v-btn>
            </template>
            {{ exibirMenuLateralEsquerdo ? 'Menu lateral estático' : 'Menu lateral dinâmico' }}
          </v-tooltip>
        </v-card-title>
        <div class="container-options">
          <v-btn-toggle v-model="modoVisualizacao" dense mandatory>
            <v-btn class="btn-acoes-atendimento">
              <v-icon color="primary">mdi-tooth</v-icon>
              Detalhes
            </v-btn>

            <v-btn class="btn-acoes-atendimento">
              <v-icon color="primary">attach_money</v-icon>
              Cobranças
            </v-btn>

            <v-btn class="btn-acoes-atendimento">
              <v-icon color="primary">build</v-icon>
              Serviços
            </v-btn>
          </v-btn-toggle>
        </div>
        <v-card-text class="card-content">
          <v-container v-if="modoVisualizacao === 0" fluid grid-list-xl white>
            <div class="container-header-atendimendo-selecionado">
              <div class="selecionado-label">
                <span class="primary--text">Dentista</span>
                <p>{{ dadosGeraisAtendimento.dentistaNome | textoSemValor }}</p>
              </div>
              <div class="selecionado-label ml-5">
                <span class="primary--text">Data de início</span>
                <p>{{ dadosGeraisAtendimento.dataInicio | filterDataHora }}</p>
              </div>
              <div class="selecionado-label ml-5">
                <span class="primary--text">Data de encerramento</span>
                <p>{{ dadosGeraisAtendimento.dataFim | filterDataHora }}</p>
              </div>
            </div>
            <div class="container-header-atendimendo-selecionado">
              <div class="selecionado-label">
                <span class="primary--text">Status</span>
                <p>{{ dadosGeraisAtendimento.status | textoSemValor }}</p>
              </div>
              <div v-if="dadosGeraisAtendimento.statusApi === 'CANCELADO'">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon color="primary" @click="alternarVisualizarMotivoCancelamento">
                      <v-icon>{{ visualizarMotivoCancelamento ? 'visibility_off' : 'visibility' }}</v-icon>
                    </v-btn>
                  </template>
                  {{ visualizarMotivoCancelamento ? 'Ver descrição' : 'Ver o motivo do cancelamento' }}
                </v-tooltip>
              </div>
            </div>
            <v-row wrap align-center white class="mt-2" v-if="!visualizarMotivoCancelamento">
              <v-col cols="12" md="12" sm="12" xs="12" v-if="!modoEdicao">
                <span class="primary--text" style="font-weight: bold">Descrição</span>
                <p>{{ dadosGeraisAtendimento.descricao }}</p>
              </v-col>
              <v-col cols="12" md="12" sm="12" xs="12" v-if="modoEdicao">
                <v-textarea
                    v-model="dadosGeraisAtendimento.descricao"
                    name="descricao"
                    placeholder="Informe a descrição do atendimento"
                    filled
                    auto-grow
                    counter="500"
                    maxlength="500"
                    class="textarea-descricao"
                >
                  <template v-slot:label>
                    Descrição
                    <span class="ml-1 red--text">*</span>
                  </template>
                </v-textarea>
              </v-col>
            </v-row>
            <v-row wrap align-center white class="mt-2" v-if="visualizarMotivoCancelamento">
              <v-col cols="12" md="12" sm="12" xs="12">
                <div class="selecionado-label">
                  <span class="primary--text">Motivo cancelamento</span>
                  <p>{{ dadosGeraisAtendimento.motivoCancelamento | textoSemValor }}</p>
                </div>
              </v-col>
            </v-row>
          </v-container>
          <odontograma-gerenciar-cobrancas v-if="modoVisualizacao === 1" :idAtendimento="dadosGeraisAtendimento.id"
                                           :statusAtendimento="dadosGeraisAtendimento.statusApi"/>
          <odontograma-gerenciar-servicos v-if="modoVisualizacao === 2" :idAtendimento="dadosGeraisAtendimento.id"
                                          :statusAtendimento="dadosGeraisAtendimento.statusApi"/>
        </v-card-text>
        <v-card-actions class="actions-footer">
          <div v-if="!modoEdicao && dadosGeraisAtendimento.permiteEditar" class="container-acoes-padrao">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" class="botao-cancelar" @click="abrirModalCancelarAtendimento" depressed>
                  <v-icon>cancel</v-icon>
                </v-btn>
              </template>
              Cancela o atendimento iniciado
            </v-tooltip>
            <v-spacer/>
            <div>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" class="botao-finalizar" @click="abrirModalFinalizarAtendimento" outlined>
                    Finalizar
                    <v-icon class="ml-1">check</v-icon>
                  </v-btn>
                </template>
                Finaliza o atendimento iniciado
              </v-tooltip>
              <v-btn class="botao-editar ml-4" @click="ativarModoEdicao"
                     outlined>Editar
                <v-icon class="ml-1">edit</v-icon>
              </v-btn>
            </div>
          </div>
          <div v-if="!modoEdicao && !dadosGeraisAtendimento.permiteEditar" class="container-acoes-padrao">
            <v-tooltip top v-if="dadosGeraisAtendimento.permiteIniciar">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" @click="iniciarAtendimento" outlined>Iniciar</v-btn>
              </template>
              Iniciar atendimento agendado
            </v-tooltip>
            <div v-if="dadosGeraisAtendimento.statusApi === 'CANCELADO'" class="mr-5">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon outlined color="grey" @click="abrirModalExcluirAtendimento">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                Excluir atendimento
              </v-tooltip>
            </div>
            <div v-if="!dadosGeraisAtendimento.permiteIniciar">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" class="btn-disabled" outlined disabled>Editar
                    <v-icon class="ml-1">edit</v-icon>
                  </v-btn>
                </template>
                Não é permitido editar atendimentos finalizados ou cancelados!
              </v-tooltip>
            </div>
          </div>
          <div v-if="modoEdicao" class="container-acoes-padrao">
            <v-btn class="botao-cancelar" @click="cancelarModoEdicao" outlined>Desfazer</v-btn>
            <v-btn class="botao-finalizar ml-4" @click="salvarEdicao" outlined>Salvar</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import {actionTypes} from '@/core/constants'
import CancelarAtendimentoModal from '@/views/modais/CancelarAtendimentoModal.vue'
import ConfirmModal from '@/views/components/ConfirmModal.vue'
import OdontogramaGerenciarCobrancas
from '@/views/pages/cadastros/paciente/comum/odontograma/cobrancas/OdontogramaGerenciarCobrancas.vue'
import OdontogramaGerenciarServicos
from '@/views/pages/cadastros/paciente/comum/odontograma/servicos/OdontogramaGerenciarServicos.vue'

export default {
    components: {OdontogramaGerenciarServicos, OdontogramaGerenciarCobrancas, ConfirmModal, CancelarAtendimentoModal},
    nome: 'OdontogramaAtualizarAtendimento',
    props: {
        atendimento: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            dadosGeraisAtendimentoAnterior: this.atendimento,
            dadosGeraisAtendimento: {
                codigo: null,
                descricao: null,
                dataInicio: null,
                dataFim: null,
                dentistaNome: null,
                permiteEditar: null
            },
            modoVisualizacao: 0,
            modalExcluir: false,
            modoEdicao: false,
            modalFinalizarAtendimento: false,
            modalCancelarAtendimento: false,
            visualizarMotivoCancelamento: false,
            exibirMenuLateralEsquerdo: true
        }
    },
    mounted() {
        this.setarDadosGerais()
    },
    methods: {
        setarDadosGerais() {
            this.dadosGeraisAtendimento = _.cloneDeep(this.atendimento)
        },
        fecharAtendimentoSelecionado() {
            this.$emit('fecharAtendimentoSelecionado')
        },
        recolherExpandirMenuLateral() {
            this.exibirMenuLateralEsquerdo = !this.exibirMenuLateralEsquerdo
        },
        ativarModoEdicao() {
            this.modoEdicao = true
        },
        cancelarModoEdicao() {
            this.modoEdicao = false
            this.dadosGeraisAtendimento = _.cloneDeep(this.dadosGeraisAtendimentoAnterior)
        },
        abrirModalCancelarAtendimento() {
            this.modalCancelarAtendimento = true
        },
        fecharModalCancelarAtendimento() {
            this.modalCancelarAtendimento = false
        },
        abrirModalFinalizarAtendimento() {
            this.modalFinalizarAtendimento = true
        },
        fecharModalFinalizarAtendimento() {
            this.modalFinalizarAtendimento = false
        },
        async cancelarAtendimento(motivoCancelamento) {
            this.setMensagemLoading('Cancelando o atendimento...')
            const input = {
                id: this.dadosGeraisAtendimento.id,
                motivoCancelamento: motivoCancelamento
            }
            const resposta = await this.$store.dispatch(actionTypes.ATENDIMENTO.CANCELAR_ATENDIMENTO, input)
            if (resposta) {
                this.dadosGeraisAtendimento = resposta
                this.dadosGeraisAtendimentoAnterior = _.cloneDeep(this.dadosGeraisAtendimento)
                this.$emit('buscarHistoricoProcedimentos')
                this.fecharModalCancelarAtendimento()
                this.mostrarNotificacaoSucessoDefault()
                this.modoCobrancas = false
            }
        },
        async finalizarAtendimento() {
            this.setMensagemLoading('Finalizando o atendimento...')
            const input = {
                id: this.dadosGeraisAtendimento.id,
            }
            await this.$store.dispatch(actionTypes.ATENDIMENTO.FINALIZAR_ATENDIMENTO, input)
            const resposta = await this.$store.dispatch(actionTypes.ATENDIMENTO.FINALIZAR_ATENDIMENTO, input)
            if (resposta) {
                this.dadosGeraisAtendimento = resposta
                this.dadosGeraisAtendimentoAnterior = _.cloneDeep(this.dadosGeraisAtendimento)
                this.mostrarNotificacaoSucessoDefault()
                this.fecharModalFinalizarAtendimento()
            }
        },
        async iniciarAtendimento() {
            this.setMensagemLoading('Iniciando atendimento...')
            const input = {
                id: this.dadosGeraisAtendimento.id,
                pacienteId: this.dadosGeraisAtendimento.pacienteId,
                dentistaId: this.dadosGeraisAtendimento.dentistaId,
                descricao: this.dadosGeraisAtendimento.descricao
            }
            const resposta = await this.$store.dispatch(actionTypes.ATENDIMENTO.INICIAR_ATENDIMENTO, input)
            if (resposta) {
                this.dadosGeraisAtendimento = resposta
                this.dadosGeraisAtendimentoAnterior = _.cloneDeep(this.dadosGeraisAtendimento)
                this.mostrarNotificacaoSucessoDefault()
                this.ativarModoEdicao()
            }
        },
        async salvarEdicao() {
            this.setMensagemLoading('Atualizando atendimento...')
            const input = {
                id: this.dadosGeraisAtendimento.id,
                descricao: this.dadosGeraisAtendimento.descricao
            }
            const resposta = await this.$store.dispatch(actionTypes.ATENDIMENTO.ATUALIZAR_ATENDIMENTO_PACIENTE, input)
            if (resposta) {
                this.dadosGeraisAtendimento = resposta
                this.dadosGeraisAtendimentoAnterior = _.cloneDeep(this.dadosGeraisAtendimento)
                this.mostrarNotificacaoSucessoDefault()
                this.modoEdicao = false
            }
        },
        alternarVisualizarMotivoCancelamento() {
            this.visualizarMotivoCancelamento = !this.visualizarMotivoCancelamento
        },
        abrirModalExcluirAtendimento() {
            this.modalExcluir = true
        },
        fecharModalExcluirAtendimento() {
            this.modalExcluir = false
        },
        async excluirAtendimento() {
            const input = {
                id: this.dadosGeraisAtendimento.id,
            }
            this.setMensagemLoading('Removendo o atendimento...')
            await this.$store.dispatch(actionTypes.ATENDIMENTO.REMOVER_ATENDIMENTO, input)
            this.mostrarNotificacaoSucessoDefault()
            this.fecharAtendimentoSelecionado()
        },
    }
}
</script>

<style scoped lang="stylus">

.container-atendimento
  border solid 1px #e0e0e0
  border-radius 10px
  height 480px
  display flex
  flex-direction column

  .v-card__title
    color white
    background-color var(--theme-primary)

.atendimento-wrapper
  position relative
  width fit-content
  opacity 1
  visibility visible

.atendimento-wrapper-recolhido
  position static
  width auto
  overflow hidden

.card-content
  flex 1 1 auto
  overflow-y auto

.actions-footer
  justify-content flex-end
  border-top 1px solid rgba(0, 0, 0, 0.12)

.container-header-atendimendo-selecionado
  display flex

.selecionado-label > span
  font-weight bold

.textarea-descricao >>> .v-label
  top 10px !important

.botao-cancelar:hover
  color orange !important

.botao-finalizar:hover
  color #22bb33 !important

.botao-editar:hover
  color #5bc0de !important

.botao-add-cobranca:hover
  color #22bb33 !important

.container-acoes-padrao
  width 100%
  display flex
  justify-content right

.container-options
  display flex
  justify-content center
  padding-top 10px

.btn-acoes-atendimento
  color var(--theme-primary) !important
  text-transform none

</style>